import React from 'react';
import isEmpty from 'lodash.isempty';
import { getPercentageSign } from './tableUtils';
import { MEASURE } from '../../constants/shared/MeasuresConstants';
import { LONG_DASH, ASTERISK, GOAL_TITLE } from '../../constants/shared/CellConstants';
import { ICON, NA } from '../../constants/shared/CommonConstants';
import ScoreInterpretationMapper from '../../constants/shared/ScoreInterpretationMapper';

export const getGoalSection = (goal, isGoalAvailable, measure, measuresWithPercentage) => {
    const goalText = goal
        ? `${GOAL_TITLE} ${goal + getPercentageSign(measuresWithPercentage, measure)}`
        : ``;
    return isGoalAvailable ? goalText : `${GOAL_TITLE} ${NA}`;
};

export const getGoalText = (goal = '') => {
    const isGoalValue = goal.trim().length;

    return isGoalValue ? `${GOAL_TITLE} ${goal}` : goal;
};

export const getScoreInterpretationLabel = (interp, proficientLevel) =>
    proficientLevel || ScoreInterpretationMapper[interp];

export const applyRightBorder = hasRightBorder => (hasRightBorder ? 'dark-right-border' : '');

export const applyLeftBorder = hasLeftBorder =>
    hasLeftBorder ? 'dark-left-border' : 'light-left-border';

const getTrcScore = (score, isUnofficial) =>
    isEmpty(score.bookType) ? (
        <span>score{isUnofficial && ASTERISK}</span>
    ) : (
        <div className="trc-info">
            <strong>{`${score.rawValue} `}</strong>
            <sup>{score.bookType}</sup>
            {score.performanceLevel}
            {isUnofficial && ASTERISK}
        </div>
    );

export const getScore = ({
    measure,
    measuresNotCompleted = [],
    measuresWithPercentage = [],
    score,
    isComplete,
    isUnofficial,
}) => {
    if (!isComplete) {
        return measuresNotCompleted.includes(measure) ? (
            <div className="infotips align-pause-icon">{ICON.PAUSED}</div>
        ) : (
            <>{LONG_DASH}</>
        );
    }

    if (measure === MEASURE.TRC) {
        return getTrcScore(score, isUnofficial);
    }

    return <>{score + getPercentageSign(measuresWithPercentage, measure)}</>;
};
